<template>
  <div class>
    <vx-card class="mb-base">
      <div class="vx-row">
        <vs-tabs>
          <vs-tab label="Main Info">
            <div class="tab-text"> 
              <div class="vx-row">
                <div class="vx-col flex-1" id="account-info-col-1">
                  <template v-for="(fName,fId) in getDataStructureInChunk[0]">
                    <vs-row :key="fId" class="p-2">
                      <vs-col class="font-semibold" vs-type="flex" vs-w="6">{{fName[1].label }}</vs-col>

                      <vs-col
                        v-if="fName[1].type == 'aronSelect'"
                        vs-type="flex"
                        vs-w="5"
                      >{{ decodeSelectValue(getMainInfo[fName[0]],fName[1].data) }}</vs-col>

                      <vs-col
                        v-else-if="fName[1].type == 'aronMultiSelect'"
                        vs-type="flex"
                        vs-w="5"
                      >{{ decodeMultiSelectValue(getMainInfo[fName[0]]) }}</vs-col>

                      <vs-col
                        v-else-if="fName[1].type == 'aronCurrency'"
                        vs-type="flex"
                        vs-w="6"
                      >{{formatCurrency(fName[1].currency, getMainInfo[fName[0]])}}</vs-col>

                      <vs-col v-else-if="fName[1].type == 'aronFile'" vs-type="flex" vs-w="6">
                        <img width="100px" height="auto" :src="showFileOrImageHandler(getMainInfo[fName[0]])" />
                      </vs-col>

                      <vs-col v-else vs-type="flex" vs-w="6">{{ getMainInfo[fName[0]] }}</vs-col>
                    </vs-row>
                  </template>
                </div>

                <div class="vx-col flex-1" id="account-info-col-2">
                  <template v-for="(fName,fId) in getDataStructureInChunk[1]">
                    <vs-row :key="fId" class="p-2">
                      <vs-col class="font-semibold" vs-type="flex" vs-w="7">{{fName[1].label }}</vs-col>

                      <vs-col
                        v-if="fName[1].type == 'aronSelect'"
                        vs-type="flex"
                        vs-w="5"
                      >{{ decodeSelectValue(getMainInfo[fName[0]],fName[1].data) }}</vs-col>

                      <vs-col
                        v-else-if="fName[1].type == 'aronMultiSelect'"
                        vs-type="flex"
                        vs-w="5"
                      >{{ decodeMultiSelectValue(getMainInfo[fName[0]]) }}</vs-col>

                      <vs-col
                        v-else-if="fName[1].type == 'aronCurrency'"
                        vs-type="flex"
                        vs-w="5"
                      >{{formatCurrency(fName[1].currency, getMainInfo[fName[0]])}}</vs-col>

                      <vs-col v-else-if="fName[1].type == 'aronFile'" vs-type="flex" vs-w="6">
                        <img width="100px" height="auto" :src="showFileOrImageHandler(getMainInfo[fName[0]])" />
                      </vs-col>

                      <vs-col v-else vs-type="flex" vs-w="5">{{ getMainInfo[fName[0]] }}</vs-col>
                    </vs-row>
                  </template>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full flex p-2" v-if="settings != undefined">
                  <template v-for="(val,id) in settings.actionButtons">
                    <vs-button
                      v-if="val.buttonType == 'action'"
                      :color="val.color"
                      :key="id"
                      :size="val.btnSize"
                      icon-pack="feather"
                      :icon="val.icon"
                      class="mr-4"
                      @click="handleSubmit(
              val.endPoint,
              val.confirmationTitle,
              val.confirmationMessage,
              val.payLoad,
              val.getReason,
              val.rejectReasonMessage,
              val.rejectDialogTitle,
              val.successMessage,
              val.sucessEventName,
              val.successEventValue,
              )"
                    >{{ val.buttonLabel }}</vs-button>

                    <vs-button
                      v-else
                      :color="val.color"
                      :key="id"
                      :size="val.btnSize"
                      icon-pack="feather"
                      :icon="val.icon"
                      class="mr-4"
                      @click="handleEmitEvent(
              val.eventName,
              val.eventValue, 
              )"
                    >{{ val.buttonLabel }}</vs-button>
                  </template>
                </div>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="PR Preview" v-if="showPR()">
            <div class="tab-text">
              <purchase-request :title="settings.invoiceTitle" />
            </div>
          </vs-tab>
          <vs-tab label="PO Preview" v-if="showPO()">
            <purchase-order :title="settings.invoiceTitle" />
          </vs-tab>
        </vs-tabs>
      </div>
    </vx-card>

    <vs-prompt
      :title="rejectDialogTitle"
      @cancel="val=''"
      @accept="validateReason"
      :active.sync="showRejectReason"
    >
      <div class="con-exemple-prompt">
        <span>{{ rejectReasonMessage }}</span>
        <vs-input
          v-validate="'required|min:3'"
          placeholder="enter your reason..."
          vs-placeholder="enter your reason..."
          v-model="reasonModel"
          class="mt-3 w-full"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { helperMixin } from "../../../mixin/helperMixin";
import { dialogMixin } from "../../../mixin/dialogMixin";
import { axiosMixin } from "../../../mixin/axiosMixin";

import { settingsMixin } from "../settingsMixin";

import axios from "@/axios.js";

import vuePdf from "../../../components/aron/dataViews/vuepdf";

import purchaseRequest from "../../../components/aron/dataViews/purchase_request.vue";
import purchaseOrder from "../../../components/aron/dataViews/purchase_order.vue";

export default {
  components: {
    purchaseRequest,
    purchaseOrder,
  },
  mixins: [helperMixin, dialogMixin, axiosMixin, settingsMixin],
  data() {
    return {
      showAlert: false,
      showRejectReason: false,
      rejectReasonMessage: "",
      reasonModel: "",
      payLoad: {},
      endPoint: "",
      rejectDialogTitle: "",
      successMessage: "",
      sucessEventName: "",
      successEventValue: "",
    };
  },
  computed: {
    ...mapGetters({
      getDataStructureInChunk: "profile/getDataStructureInChunk",
      getMainInfo: "profile/getMainInfo",
    }),
    settings() {
      this.showAlert = true; //we need to trigger this so that the alert will show

      return this.getMainInfoSettings(
        this.$route.params.subject,
        this.$route.params.key
      );
    },
    baseURl() {
      return axios.defaults.baseURL;
    },
  },
  created() {
    console.log("getMainInfoFromServer:", this.getMainInfoFromServer());
  },
  updated() {
    //   console.log("getMainInfo:", this.getMainInfo);
    // console.log("getDataStructureInChunk:", this.getDataStructureInChunk);
  },
  methods: {
    showPR() {
      if (this.settings != undefined) {
        if (this.settings.hasOwnProperty("showInvoicePreview")) {
          if (this.settings.showInvoicePreview) {
            return true;
          }
        }
      }

      return false;
    },
    getMainInfoFromServer() {
      let settings = this.getSettings(
        this.$route.params.subject,
        this.$route.params.key
      );
      if (settings != undefined) {
        if (settings.hasOwnProperty("updateMainInfoWhenLoaded")) {
          console.log("route:", settings.updateMainInfoWhenLoaded.route);
          this.aronGet(
            settings.updateMainInfoWhenLoaded.route +
              "/" +
              this.$store.state.profile.profileId,
            "",
            ""
          )
            .then((response) => {
              this.$store.dispatch("profile/setMainInfo", response.data.data);
            })
            .catch((error) => {
              console.log("error from getMainInfoFromServer");
            });
        }
      }
    },
    showPO() {
      if (this.settings != undefined) {
        if (this.settings.hasOwnProperty("showPOPreview")) {
          if (this.settings.showPOPreview) {
            return true;
          }
        }
      }

      return false;
    },
    handleEmitEvent(eventName, eventValue) {
      this.$emit(eventName, { eventName: eventName, eventValue: eventValue });
    },
    handleSubmit(
      endPoint,
      title,
      message,
      payLoad,
      getReason,
      rejectReasonMessage,
      rejectDialogTitle,
      successMessage,
      sucessEventName,
      successEventValue
    ) {
      this.payLoad = payLoad;
      this.endPoint = endPoint;
      this.successMessage = successMessage;
      this.sucessEventName = sucessEventName;
      this.successEventValue = successEventValue;
      this.successMessage = successMessage;
      if (getReason) {
        this.showRejectReason = true;
        this.rejectReasonMessage = rejectReasonMessage;
        this.rejectDialogTitle = rejectDialogTitle;
      } else {
        this.confirmAlert(title, message).then((res) => {
          this.submitNow();
        });
      }
    },
    validateReason() {
      if (this.reasonModel == "") {
        this.errorAlert("Required", "The Reason field is required");
        this.showRejectReason = true;
      } else {
        this.addToObject(this.payLoad, { rejectReason: this.reasonModel });
        this.submitNow();
      }
    },
    submitNow() {
      console.log('event:', this.sucessEventName + " val: " + this.successEventValue);
      this.aronPost(this.endPoint, this.payLoad, "", "")
        .then((response) => {
          if (response.data.status == "success") {
            this.normarAlert("Success", this.successMessage).then((res) => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue,
              });
            });
          } else {
            this.normarAlert(
              "Error",
              "Something Went wrong please try again later"
            ).then((res) => {
              this.$emit(this.sucessEventName, {
                eventName: this.sucessEventName,
                eventValue: this.successEventValue,
              });
            });
          }

          //go back
        })
        .catch((error) => {
          console.log("error ActionContainer reason:", error);
        });
    },
    showFileOrImageHandler(source) {
      if (source != undefined) {
        var filename = this.getFileExtention(source);
        if (filename == "pdf") {
          this.showPdf = true;
          this.thePdfSource = this.baseURl + "/storage/" + source;
        } else if (
          filename == "jpeg" ||
          filename == "jpg" ||
          filename == "png" ||
          filename == "gif"
        ) {
          this.showImage = true;
          return this.baseURl + "/storage/" + source;
        }
      }
    },
    editData() {},
    formatCurrency(currency, value) {
      return this.displayCurrency(currency, value);
    },
    decodeSelectValue(value, options) {
      console.log("value:", value);
      console.log("options:", options);
      return this.decodeValueForSelect(options, value);
    },
    decodeMultiSelectValue(value) {
      return this.flattenJsonStringArray(value, "label");
    },
  },
};
</script>
